<template>
  <v-app>
    <router-view class="bg">
      <v-content>
        <HelloWorld />
      </v-content>
    </router-view>
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",

  components: {
    HelloWorld
  },

  data: () => ({
    //
  })
};
</script>

<style scoped>
.bg {
  /* background-color: #485461;
  background-image: linear-gradient(315deg, #485461 0%, #28313b 74%); */

background-color: #d2a813;
background-image: linear-gradient(315deg, #d2a813 60%, #000000 100%);
}
</style>
